import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "../../../tooltip/src";
export const AddOptionalTooltip = ({ children, tooltip, }) => tooltip ? (_jsx(Tooltip, { childrenElement: tooltip, hideOnScreenReader: true, children: children })) : (children);
//# sourceMappingURL=AddOptionalTooltip.js.map